// eslint-disable-next-line import/no-cycle
import { eventsTypeEnum } from '@/types';

type eventProperties = {
  contact: Record<string, any>;
  visitor: Record<string, any>;
  metaData: Record<string, any>;
  params?: Record<string, any>;
}

export type eventType = {
  display: boolean;
  label: string;
  logo_box: string;
  code_name: string;
  subcomponent: string;
  type: string;
  properties: eventProperties;
  persistant?: boolean;
  component?: string;
};

export const predefinedEvents: { [key: string]: eventType } = {
  upsert_order: {
    display: true,
    label: 'automatedScenarios.triggers.statusCommand.label',
    logo_box: 'fa-bags-shopping',
    code_name: 'upsert_order',
    subcomponent: 'boxstatuscommand',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [
        {
          name: 'order_id',
          label: 'metadata.order_id',
          type: 'text',
          description: '',
          required: true,
          primary: true,
          updateData: false,
          targetSchemaType: 'system',
          targetSchema: 'orders',
          targetField: 'order_id',
        },
        {
          name: 'order_status',
          label: 'metadata.order_status',
          type: 'text',
          description: '',
          required: true,
          primary: true,
          updateData: false,
          optionsSource: 'orderStatus',
        },
      ],
    },
    persistant: true,
  },
  abandon_cart: {
    display: true,
    label: 'automatedScenarios.triggers.abandonPanier.label',
    logo_box: 'fa-shopping-cart',
    code_name: 'abandon_cart',
    subcomponent: 'boxabandonpanier',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [{
        name: 'cart_id',
        label: 'metadata.cart_id',
        type: 'text',
        description: '',
        required: true,
        primary: true,
        updateData: false,
        targetSchemaType: 'system',
        targetSchema: 'carts',
        targetField: 'cart_id',
      }],
    },
    persistant: true,
  },
  quit_site: {
    display: true,
    label: 'automatedScenarios.triggers.quitSite.label',
    logo_box: 'fa-sign-out',
    code_name: 'quit_site',
    subcomponent: 'boxquitsite',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
      params: {},
    },
    component: 'DeclencheurQuitSite',
  },
  pass_time: {
    display: true,
    label: 'automatedScenarios.triggers.passTime.shortLabel',
    logo_box: 'fa-clock',
    code_name: 'pass_time',
    subcomponent: 'boxsitepasstime',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
      params: {},
    },
    component: 'DeclencheurSitePassTime',
  },
  register_on_site: {
    display: true,
    label: 'automatedScenarios.triggers.registerOnSite.label',
    logo_box: 'fa-user-plus',
    code_name: 'register_on_site',
    subcomponent: 'boxregisteronsite',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
    },
  },
  subscribe_newsletter: {
    display: true,
    label: 'automatedScenarios.triggers.subscribeToNewsletter.label',
    logo_box: 'fa-envelope-open',
    code_name: 'subscribe_newsletter',
    subcomponent: 'boxsubscribetonewsletter',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
    },
  },
  scroll: {
    display: true,
    label: 'automatedScenarios.triggers.scrollPage.shortLabel',
    logo_box: 'fa-arrows-v',
    code_name: 'scroll',
    subcomponent: 'boxscrollpage',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
      params: {},
    },
    component: 'DeclencheurScrollPage',
  },
  visit_page: {
    display: true,
    label: 'automatedScenarios.triggers.boxVisitPage.label',
    logo_box: 'fa-eye',
    code_name: 'visit_page',
    subcomponent: 'boxvisitpage',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
      params: {},
    },
    component: 'DeclencheurVisitPage',
  },
  custom_js: {
    display: true,
    label: 'automatedScenarios.triggers.customJS.label',
    logo_box: 'fa-flask',
    code_name: 'custom_js',
    subcomponent: 'boxcustomjs',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
      params: {},
    },
    component: 'DeclencheurCustomJs',
  },
  wait: {
    display: false,
    label: '',
    logo_box: '',
    code_name: 'wait',
    subcomponent: 'boxwait',
    type: eventsTypeEnum.INTERNAL,
    properties: {
      contact: {},
      visitor: {},
      metaData: [],
      params: {},
    },
  },
};
